/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Linux_ArchInputs */

const en_gc_resources_download_linux_arch = /** @type {(inputs: Gc_Resources_Download_Linux_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`64-bit Linux · x86_64 AppImage`)
};

const zh_gc_resources_download_linux_arch = /** @type {(inputs: Gc_Resources_Download_Linux_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`64 位 Linux · x86_64 AppImage`)
};

/**
* | output |
* | --- |
* | "64-bit Linux · x86_64 AppImage" |
*
* @param {Gc_Resources_Download_Linux_ArchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_linux_arch = /** @type {((inputs?: Gc_Resources_Download_Linux_ArchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Linux_ArchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_linux_arch(inputs)
	return zh_gc_resources_download_linux_arch(inputs)
});
export { gc_resources_download_linux_arch as "gc.resources.download.linux.arch" }